import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
	title: {
		textTransform: "uppercase"
	},
	tableCell: {
		paddingTop: theme.spacing(1.5),
		paddingBottom: theme.spacing(1.5)
	},
	noContactsText: {
		color: colors.gray[700],
		fontWeight: 300,
		lineHeight: "1.5em",
		textTransform: "uppercase",
		[theme.breakpoints.down("sm")]: {
			textAlign: "center"
		}
	},
	clearContactsChip: {
		...ColorUtil.getBackgroundAndContrastColor(colors.yellow[100]),
		fontSize: 14,
		height: 20
	},
	customInfoIcon: {
		width: 15,
		height: 15,
		margin: "0px 1px 0px 5px",
		color: "rgba(0, 0, 0, 0.54)"
	},
	messageBlastMetrics: {
		display: "flex",
		flexDirection: "row"
	},
	logo: {
		display: "block",
		margin: "0 auto",
		maxWidth: "120px",
		height: "auto"
	}
}))

export default useStyles
